/**
 * ⚠️ 중요: 이 패키지는 더 이상 사용되지 않습니다
 *
 * @coxwave/tap-kit으로 마이그레이션해 주세요!
 *
 * 마이그레이션 방법:
 * 1. 설치: npm install @coxwave/tap-kit
 * 2. import 변경:
 *    [기존] import TapSDK from '@coxwave/tap-sdk'
 *    [신규] import TapKit from '@coxwave/tap-kit'
 * 3. 클래스명만 변경하면 끝! (API는 100% 호환)
 *
 * 자세한 내용: https://edutap-ai-docs.vercel.app/docs/migration/tap-sdk-to-tap-kit
 */

export type * from "@coxwave/tap-kit";
// Re-export from tap-kit (TAPKIT_CONFIG_SYMBOL removed - renamed to __TAPKIT_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED)
export { default } from "@coxwave/tap-kit";

// 한국어 경고 메시지 (한 번만 출력)
if (typeof window !== "undefined" && !window.__TAP_SDK_DEPRECATION_WARNED__) {
  console.warn(
    "\n" +
      "┌─────────────────────────────────────────────────────────────┐\n" +
      "│  ⚠️  @coxwave/tap-sdk는 더 이상 사용되지 않습니다           │\n" +
      "├─────────────────────────────────────────────────────────────┤\n" +
      "│  새로운 패키지로 마이그레이션해 주세요:                     │\n" +
      "│                                                             │\n" +
      "│  📦 설치:                                                   │\n" +
      "│     npm install @coxwave/tap-kit                           │\n" +
      "│                                                             │\n" +
      "│  📝 사용법 (변경 사항 최소):                                │\n" +
      "│     [기존] import TapSDK from '@coxwave/tap-sdk'           │\n" +
      "│     [신규] import TapKit from '@coxwave/tap-kit'           │\n" +
      "│                                                             │\n" +
      "│     [기존] const sdk = new TapSDK({ ... })                 │\n" +
      "│     [신규] const kit = new TapKit({ ... })                 │\n" +
      "│                                                             │\n" +
      "│  ✅ API는 100% 호환됩니다!                                  │\n" +
      "│                                                             │\n" +
      "│  📖 자세한 마이그레이션 가이드:                             │\n" +
      "│     https://edutap-ai-docs.vercel.app/docs/migration/tap-sdk-to-tap-kit │\n" +
      "└─────────────────────────────────────────────────────────────┘\n"
  );
  window.__TAP_SDK_DEPRECATION_WARNED__ = true;
  window.__TAP_SDK_IMPORTED__ = true;
}

declare global {
  interface Window {
    __TAP_SDK_DEPRECATION_WARNED__?: boolean;
    __TAP_SDK_IMPORTED__?: boolean;
  }
}
